import type { Item } from '@easymoving/types';

export type ItemVisual =
  | { kind: 'photo'; url: string }
  | { kind: 'icon'; iconType: string }
  | { kind: 'none' };

/**
 * How to visually represent an item: its photo if it has one, else its chosen
 * furniture-type icon, else a neutral placeholder. `thumb` picks the thumbnail
 * URL (gallery cards) vs the full image (detail).
 */
export function itemVisual(item: Item, opts: { thumb?: boolean } = {}): ItemVisual {
  const url = opts.thumb ? (item.primaryThumbUrl ?? item.primaryImageUrl) : item.primaryImageUrl;
  if (url) return { kind: 'photo', url };
  if (item.iconType) return { kind: 'icon', iconType: item.iconType };
  return { kind: 'none' };
}
